<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">品牌列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body">
            <brand-table />
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import brandTableTemp from './Temp/BrandTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1,
      show: {
        menu: false,
        menuDetail: false
      }
    }
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  components: {
    'brand-table': brandTableTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// BrandTable.vue?77e17f98